<template>

  <div>

    <v-row class="mt-2">
      <v-col class="text-center" cols="12">

        <h3>Торговая организация
          <font-awesome-icon v-if="selectedItem.id && !disabled" @click="onSubmit()" icon="edit" role="button" style="font-size: 22px; color: seagreen;" class="ml-3 edit_icon"/>
        </h3>

      </v-col>
    </v-row>

    <div class="v-input v-text-field theme--light">
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-text-field__slot">
            <label aria-hidden="true" class="v-label v-label--active theme--light"
                   style="left: 0px; right: auto; position: absolute;">Торговая организация</label>

            <el-autocomplete
              v-model="searchOrganization"
              :fetch-suggestions="AutocompleteSearch"
              @select="AutocompleteSelect"
              placeholder="Выберите из списка или добавьте новую"
              :trigger-on-focus="false"
              id="trade_organization"
              value-key="name"
              value="id"
              clearable
              required
              :disabled="disabled"
            ></el-autocomplete>
          </div>
        </div>
        <div class="v-text-field__details">
          <div class="v-messages theme--light">
            <div class="v-messages__wrapper"></div>
          </div>
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="12" sm="6" class="mt-2">
        <v-text-field
          type="text"
          label="Адрес"
          id="address"
          v-model="selectedItem.address"
          disabled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" class="mt-2">
        <v-text-field
          type="text"
          label="Телефон"
          id="phone"
          v-model="selectedItem.phone"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-2">
        <v-text-field
          type="text"
          label="Контактное лицо"
          id="contact_person"
          v-model="selectedItem.contact_person"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>

<!--    <v-row v-if="selectedItem.id && !disabled">-->
<!--      <v-col cols="12" class="text-right pb-2">-->
<!--        <v-btn small @click="onSubmit()">-->
<!--                      <span>-->
<!--                          Редактировать торговую организацию-->
<!--                      </span>-->
<!--          <font-awesome-icon icon="paper-plane" class="size-16 ml-1"/>-->
<!--        </v-btn>-->
<!--      </v-col>-->
<!--    </v-row>-->

    <v-dialog  width="500" v-model="showDialog">
      <v-card>
        <v-card-title class="headline primary">
          {{ this.editItem.id ? 'Редактрирование ' : 'Добавление ' }} Торговой организации
        </v-card-title>
        <v-card-text>

          <v-row>
            <v-col cols="12" class="mt-2">
              <v-text-field
                v-model="editItem.name"
                label="Название"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="v-input v-text-field theme--light">
            <div class="v-input__control">
              <div class="v-input__slot">
                <div class="v-text-field__slot">
                  <label aria-hidden="true" class="v-label v-label--active theme--light"
                         style="left: 0px; right: auto; position: absolute;">Адрес</label>

                  <el-autocomplete
                    v-model="editItem.address"
                    :fetch-suggestions="AutocompleteSearchAddress"
                    @select="AutocompleteSelectAddress"
                    placeholder="Москва, Тверской б-р, д 9"
                    :trigger-on-focus="false"
                    id="trade-organization-address"
                  ></el-autocomplete>
                </div>
              </div>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper"></div>
                </div>
              </div>
            </div>
          </div>

          <v-row>
            <v-col cols="12" class="pt-0">
              <v-text-field
                id="phone"
                type="text"
                label="Телефон"
                v-model="editItem.phone"
                placeholder=""
                v-mask="'+7 (###) ###-####'"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="mt-2">
              <v-text-field
                v-model="editItem.contact_person"
                label="Контактное лицо"
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
        <v-divider>

        </v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
<!--          <v-btn color="default" @click="clearForm">Отклонить</v-btn>-->
          <v-btn @click="sendForm">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'TradeOrganization',
  props: {
    existSelectedItem: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [],
    suggestions: [],
    editItem: {

    },
    selectedItem: {
      id: '',
      address: '',
      phone: '',
      name: '',
      contact_person: '',
    },
    searchOrganization: '',
    rules: {
      required: v => !!v || 'Поле должно быть заполнено',
      phone: v => (!v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
    },
    showDialog: false,
  }),
  mounted() {
    if (this.existSelectedItem) {
      this.selectedItem = this.existSelectedItem;
      this.searchOrganization = this.existSelectedItem.name;
      this.items.push(this.selectedItem);
    }
  },
  computed: {
    allItems() {
      return [...this.items, { id: 'new', name: 'Добавить новую организацию' }];
    },
  },
  methods: {
    AutocompleteSearch(queryString, cb) {
      const app = this;
      this.clearSelectedItem();
      return app.$store.getters.ax.post('sales/api/trade-organization', { name: queryString })
        .then((response) => {
          if (response.data.trade_organizations !== null
            && Array.isArray(response.data.trade_organizations)) {
            app.items = response.data.trade_organizations;
          }

          cb(app.allItems);
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
          cb(app.allItems);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    AutocompleteSelect(item) {
      if (item.id === 'new') {
        this.clearForm();
        this.searchOrganization = '';
        this.showDialog = true;
      } else {
        this.items.forEach((sug) => {
          if (sug.id === item.id) {
            this.selectedItem = sug;
            this.$emit('select', sug);
            document.getElementById('trade_organization').focus();
          }
        });
      }
    },
    onSubmit() {
      this.editItem = this.selectedItem;
      this.showDialog = true;
    },
    clearForm() {
      this.editItem = {
        id: '',
        address: '',
        phone: '',
        name: '',
        contact_person: '',
      };
      this.showDialog = false;
    },
    clearSelectedItem() {
      this.selectedItem = {
        id: '',
        address: '',
        phone: '',
        name: '',
        contact_person: '',
      };
      this.$emit('select', {});
    },
    sendForm() {
      const app = this;
      const urlMethod = app.editItem.id ? 'update' : 'create';

      const item = app.editItem;
      item.phone_local = item.phone;

      return app.$store.getters.ax.post(`sales/api/trade-organization/${urlMethod}`, item)
        .then((response) => {
          this.items = [response.data.trade_organization, ...this.items];
          this.searchOrganization = response.data.trade_organization.name;
          this.selectedItem = response.data.trade_organization;
          this.$emit('select', this.selectedItem);
          this.clearForm();
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    AutocompleteSearchAddress(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelectAddress(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          document.getElementById('trade-organization-address').focus();
        }
      });
    },
  },
};
</script>

<style lang="scss">

  .el-autocomplete {
    width: 100%;

    .el-input__inner {
      border: none;
    }
  }

  .edit_icon:hover {
    opacity: 0.7;
  }

</style>
